<div ng-controller="channelPropertyController as ctrl" class="channel-property">
    <div class="modal-view">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>